


import { Component, Prop, Vue } from "vue-property-decorator";

import { SearchResult } from '../../models/search-viewmodel';

import LinkDirective from '@/shared/directives/link-directive';

import { useState } from "vuex-composition-helpers";

@Component({
    directives: {
        LinkDirective
    }
})
export default class ResultComponent extends Vue {
    @Prop() item!: SearchResult;
    @Prop({ default: 0 }) resultsCount!: number;

    trackSearchResultsClick(): void {
        if (typeof window === "undefined") {
            return;
        }

        const searchQuery = (document.getElementById("Query") as HTMLInputElement)?.value?.trim() || "";
        const searchClick = this.item?.title || "";

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "search_results_click",
            search_query: searchQuery,
            search_display: String(this.resultsCount),
            search_click: searchClick,
            search_bar_type: "overlay",
        });
    }
}
